export default class {
  constructor({ selector }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelectorAll(selector)
    const isTouchDevice = document.documentElement.classList.contains('isTouchDevice')
    //Methods
    !isTouchDevice && this.initButtonHover()
  }

  initButtonHover() {    
    this.selector.forEach(btn => {
      btn.addEventListener('mouseenter', (e) => {
        let bounds = btn.getBoundingClientRect()
        let x = ((e.clientX - bounds.left) / btn.offsetWidth) - 0.5
        let y = ((e.clientY - bounds.top) / btn.offsetHeight) - 0.5
        // let x = (e.clientX / btn.offsetWidth) - 0.5
        // let y = ((e.clientY + (btn.offsetWidth - btn.offsetHeight) / 2) / btn.offsetWidth) - 0.5       
        btn.style.setProperty("--x", (100 * x) + "%")
        btn.style.setProperty("--y", (100 * y) + "%")
      })
    })

  }

}